$('document').ready(function () {
  // Page Loader
  $('.page-loader').fadeOut();

  // Interactive list
  $('body').on('click', '.interactive-list.mobile-list li', function (e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).find('span').removeClass('active');
    } else {
      $('.interactive-list.mobile-list li').removeClass('active');
      $(this).find('span').addClass('active');
      $(this).addClass('active');
    }
  });

  if ($('.interactive-list.desktop-list').length) {
    let linesArr = [];

    let totalDots = document.querySelectorAll('.interactive-list.desktop-list li').length;

    for (let i = 0; i < totalDots - 1; i++) {
      let line = new LeaderLine(
        document.getElementById('dot-' + (i + 1)),
        document.getElementById('dot-' + (i + 2)),
        { color: '#FF1E00', size: 2, startPlug: 'behind', endPlug: 'behind', path: 'straight' }
      )
      linesArr.push(line);
    };

    function linePos() {
      linesArr.forEach((l, i) => {
        l.position();
      });
    }

    $('.interactive-list.desktop-list li').mouseover(function () {
      event.preventDefault();
      $('.interactive-list.desktop-list li').removeClass('active');
      $(this).addClass('active');
      $(this).parent().addClass('active');

      const intervalId = window.setInterval(function () {
        linePos();
      }, 10);

      setTimeout(function () {
        clearInterval(intervalId);
      }, 400);
    });

    window.setInterval(function () {
      linePos();
    }, 10);
  }

  $('.interactive-list.desktop-list li').mouseout(function () {
    event.preventDefault();
    $('.interactive-list.desktop-list').removeClass('active');
    $('.interactive-list.desktop-list li').removeClass('active');

    const intervalId = window.setInterval(function () {
      linePos();
    }, 10);

    setTimeout(function () {
      clearInterval(intervalId);
    }, 400);
  });

  // Toggle Long Text
  $('.toggle-text-button').click(function (e) {
    e.preventDefault();

    if ($(this).parent().parent().find('.toggle-text').hasClass('collapsed')) {
      $(this).parent().parent().find('.toggle-text').removeClass('collapsed');
      $(this).find('span').text('Read less');
    } else {
      $(this).parent().parent().find('.toggle-text').addClass('collapsed');
      $(this).find('span').text('Read more');
    }
  });

  // Grid Files: Show More
  $('.grid-files-more').click(function (e) {
    e.preventDefault();

    let buttonLabel = $(this).find('span');

    $(this).closest('.list-wrapper').find('.extra-files').slideToggle(300).toggleClass('hidden');
    $(buttonLabel).text($(buttonLabel).text() == 'Show more' ? 'Show less' : 'Show more');
  })

  // Address Toggle
  $('html').on('click', '.address-toggle > a', function (event) {
    event.preventDefault();
    if ($(this).parent().hasClass('active')) {
      $('.address-block').removeClass('active');
      $('.address-toggle').removeClass('active');
    } else {
      $('.address-block').removeClass('active');
      $('.address-toggle').removeClass('active');
      $(this).parent().find('.address-block').addClass('active');
      $(this).parent().addClass('active');
    }
  });

  // Interactive Map
  $('.map-locations li[data-name=liverpool]').addClass('active');
  $('html').on('click', '.map-locations .list-group-item > a', function (event) {
    event.preventDefault();
    var location = $(this).parent().data('name');
    $('.map-bg .dot').removeClass('focus');
    $('.map-bg').find('#' + location).addClass('focus');
    $('.map-bg').find('#' + location).prev().addClass('focus');
  });
  $('html').on('click', '.map-bg .dot', function (event) {
    event.preventDefault();
    var location = $(this).attr('id');
    $('.map-bg .dot').removeClass('focus');
    $('.map-locations li').removeClass('active');
    $(this).addClass('focus');
    $(this).prev().addClass('focus');
    $('.map-locations li[data-name=' + location + ']').addClass('active');
  });

  // Accordion + Tabs
  if ($('.show-accordion').length) {
    let accordButton = $('.show-accordion');
    let accordDiv = $(accordButton).parent().find('.accordion')

    $(accordButton).click(function () {
      $(this).toggleClass('active');
      $(this).parent().find('.accordion').slideToggle();
    });

    $('.tabs a').click(function () {
      $(accordButton).removeClass('active');
      $(accordDiv).hide();
    });
  }

  // Anchoring for accordions on smaller screens only
  $('.accordion-button').on('click', function () {
    if (screen.width < 500) {
      setTimeout(() => {
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 0);
      }, 250);
    }
  });

  $('.show-accordion').on('click', function () {
    if (!$(this).hasClass('active')) {
      $(this).find('span').text('Read more');
      if (screen.width < 500) {
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $(this).parent().parent().offset().top - 100
          }, 0);
        }, 250);
      }
    } else {
      $(this).find('span').text('Read less');
    }
  });

  // Hide featured article if URL contains paramaters
  function refresh() {
    if (window.location.href.indexOf("?_") > -1) {
      $('.featured-insight').hide();
      $('.feat-insight-title').hide();
    } else {
      $('.featured-insight').show();
      $('.feat-insight-title').show();
    }
    setTimeout(refresh, 500);
  }
  setTimeout(refresh, 100);

  // Pause video if modal closes
  if (document.getElementById('videoModal')) {
    const modal = document.getElementById('videoModal');
    const iframe = document.querySelector("#videoModal iframe");

    modal.addEventListener('hidden.bs.modal', event => {
      console.log('modal hidden');
      let command = {
        event: "command",
        func: "pauseVideo"
      };
      iframe.contentWindow.postMessage(JSON.stringify(command), "*");
    })
  }
  // const modal = $('#videoModal');
  // const iframe = $(modal).find('iframe');

  // modal.addEventListener('hidden.bs.modal', event => {
  //   let command = {
  //     event: "command",
  //     func: "pauseVideo"
  //   };
  //   iframe.contentWindow.postMessage(JSON.stringify(command), "*");
  //   alert('modal hidden');
  // })
});
